import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LANG_NAMES as NAMES } from 'i18n/langs';

class LanguagePicker extends Component {
  static propTypes = {
    lang: PropTypes.string,
    langs: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func
  };
  state = { open: false };
  triggerRef = React.createRef();
  componentDidMount() {
    document.addEventListener('click', this.close);
    document.addEventListener('keydown', this.onKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.close);
    document.removeEventListener('keydown', this.onKeyDown);
  }
  close = () => {
    if (this.state.open) this.setState({ open: false });
  };
  onKeyDown = e => {
    if (e.key === 'Escape' && this.state.open) {
      this.setState({ open: false });
      if (this.triggerRef.current) this.triggerRef.current.focus();
    }
  };
  onMenuKeyDown = e => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    e.preventDefault();
    const items = Array.from(e.currentTarget.querySelectorAll('button'));
    const idx = items.indexOf(document.activeElement);
    const next = e.key === 'ArrowDown'
      ? (idx + 1) % items.length
      : (idx - 1 + items.length) % items.length;
    items[next].focus();
  };
  toggle = e => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ open: !this.state.open });
  };
  select = l => {
    this.setState({ open: false });
    if (l !== this.props.lang) this.props.onSelect(l);
  };
  render() {
    const styles = require('./LanguagePicker.less');
    const { lang, langs } = this.props;
    return (
      <div className={styles.picker} onClick={e => e.nativeEvent.stopImmediatePropagation()}>
        <button
          type="button"
          ref={this.triggerRef}
          className={`${styles.trigger} ${this.state.open ? styles.triggerOpen : ''}`}
          aria-haspopup="menu"
          aria-expanded={this.state.open}
          aria-label="Язык / Language"
          onClick={this.toggle}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <ellipse cx="12" cy="12" rx="4" ry="9" />
            <path d="M3.6 9h16.8" />
            <path d="M3.6 15h16.8" />
          </svg>
          <span className={styles.code}>{lang}</span>
          <svg className={styles.chevron} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        {this.state.open && (
          <div className={styles.menu} role="menu" onKeyDown={this.onMenuKeyDown}>
            {langs.map(l => (
              <button
                key={l}
                type="button"
                role="menuitemradio"
                aria-checked={lang === l}
                className={`${styles.item} ${lang === l ? styles.itemActive : ''}`}
                onClick={() => this.select(l)}
              >
                <span className={styles.check} aria-hidden="true">
                  {lang === l && (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </span>
                <span className={styles.name}>{NAMES[l] || l.toUpperCase()}</span>
                <span className={styles.itemCode}>{l}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default LanguagePicker;
